import IdeyaModal from '@/common/antd/ideya-modal.tsx'
import { useGetDailyIdeaPnlQuery } from '@/apis/idea/idea-api.api.ts'
import { IdeyaSpinner } from '@/common/components/ideya-spinner.tsx'
import { IdeaHistory } from './idea-history.tsx'
import { IdeyaButton } from '@/common/antd/ideya-button/ideya-button.tsx'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

interface IdeaHistoryModalProps {
  showHistoryModal: boolean
  ideaId?: string | null
  handleCloseModal: () => void
}

export const IdeaHistoryModal: React.FC<IdeaHistoryModalProps> = ({
  showHistoryModal,
  ideaId,
  handleCloseModal,
}) => {
  const [showContent, setShowContent] = useState<boolean>(false)
  const { t } = useTranslation()

  const {
    currentData: pnlData,
    isLoading: isLoadingPnl,
    isFetching: isFetchingPnl,
    refetch: refetchPnl,
  } = useGetDailyIdeaPnlQuery(ideaId ?? '', { skip: !ideaId })

  useEffect(() => {
    if (!showHistoryModal || !ideaId) return
    refetchPnl()
  }, [showHistoryModal, ideaId, refetchPnl])

  // Only show contents after modal is fully rendered
  const handleAfterOpenChange = (visible: boolean) => {
    setShowContent(visible)
  }

  return (
    <IdeyaModal
      title={
        pnlData
          ? pnlData?.data.ticker.tickerCode + ' ' + pnlData?.data.ticker.name
          : ''
      }
      open={showHistoryModal}
      width={900}
      onCancel={() => {
        handleCloseModal()
        setShowContent(false)
      }}
      afterOpenChange={handleAfterOpenChange}
      footer={
        <IdeyaButton onClick={handleCloseModal}>
          {t('common.got_it')}
        </IdeyaButton>
      }
    >
      <div
        style={{
          height: '75dvh',
          overflow: 'auto',
        }}
      >
        {isLoadingPnl || isFetchingPnl ? (
          <IdeyaSpinner />
        ) : pnlData?.data && showContent ? (
          <IdeaHistory pnlData={pnlData.data} />
        ) : null}
      </div>
    </IdeyaModal>
  )
}
